<ng-container [ngSwitch]='item?.type'>

  <pt-sidebar-item-title
    *ngSwitchCase='T.TITLE'
    [collapsed]='collapsed'
    [item]='item'>
  </pt-sidebar-item-title>

  <pt-sidebar-item-logo
    *ngSwitchCase='T.LOGO'
    [collapsed]='collapsed'
    [item]='item'>
  </pt-sidebar-item-logo>

  <pt-sidebar-item-link
    *ngSwitchCase='T.LINK'
    [collapsed]='collapsed'
    [item]='item'
    [selectionMode]='selectionMode'>
  </pt-sidebar-item-link>

  <pt-sidebar-item-link
    *ngSwitchCase='T.LINK_SEPARATOR'
    [collapsed]='collapsed'
    [item]='item'
    [selectionMode]='selectionMode'>
  </pt-sidebar-item-link>

  <pt-sidebar-item-button
    (openMenu)='openMenu.emit($event)'
    *ngSwitchCase='T.BUTTON'
    [collapsed]='collapsed'
    [item]='item'>
  </pt-sidebar-item-button>

  <pt-sidebar-item-menu
    (clickItem)='openMenu.emit($event)'
    *ngSwitchCase='T.MENU'
    [autoCloseMenuItem]='autoCloseMenuItem'
    [collapsed]='collapsed'
    [itemMenuOpenedId]='itemMenuOpenedId'
    [item]='item'>
  </pt-sidebar-item-menu>
</ng-container>


